/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

// components
import MapsInterface from './MapsInterface';
import ManualZipEntry from './ManualZipEntry';
import StateZipEntry from './StateZipEntry';
import { LoaderButton } from '../../../components';

function AgentWithManualZipEntry({ reduxProfile }) {
  const { travelZips = [] } = (reduxProfile || {});
  const displayValue = travelZips.join('\n');
  return (
    <div className="row">
      <div className="col">
        Your administrator has manually set up your location preferences for you.
        These are the zipcodes they have set.
      </div>

      <div className="d-flex col">
        <textarea
          disabled
          style={{ height: '200px', overflowY: 'scroll' }}
          value={displayValue}
        />
      </div>
    </div>
  );
}

function ZipInterface({
  disabled,
  setReduxProfileKeys,
  setReduxAppointments,
  reduxProfile,
  canEditLocation,
  awsConfig,
  awsConfigUseDataSite = false,
  radiusOptions = [],
  allowManualZipEntry = false,
  allowStateZipEntry = false,
  setManualZipInputValid,
  manualZipInputValid,
}) {
  const { zipEntryType = 'map' } = reduxProfile;

  if (canEditLocation && !allowManualZipEntry && (zipEntryType === 'manual')) {
    return <AgentWithManualZipEntry reduxProfile={reduxProfile} />;
  } else if (!canEditLocation) {
    return (
      <div>Your account does not have permission to edit location preferences.</div>
    );
  }

  return (
    <>
      <div className="row">
        <header className="mb-4">
          <h3 className={disabled ? 'text-muted' : ''}>
            Where I will travel for in person meetings
          </h3>
          {(allowStateZipEntry || allowManualZipEntry) && (
            <LoaderButton
              type="button"
              className={`btn ${(zipEntryType === 'map') ? 'btn-secondary' : 'btn-outline-secondary'}`}
              text="Map"
              loadingText="Map"
              onClick={() => setReduxProfileKeys({ zipEntryType: 'map' })}
            />
          )}
          {allowStateZipEntry && (
            <LoaderButton
              type="button"
              className={`ms-3 btn ${(zipEntryType === 'state') ? 'btn-secondary' : 'btn-outline-secondary'}`}
              text="State"
              loadingText="State"
              onClick={() => setReduxProfileKeys({ zipEntryType: 'state' })}
            />
          )}
          {allowManualZipEntry && (
            <LoaderButton
              type="button"
              className={`ms-3 btn ${(zipEntryType === 'manual') ? 'btn-secondary' : 'btn-outline-secondary'}`}
              text="Manual"
              loadingText="Manual"
              onClick={() => setReduxProfileKeys({ zipEntryType: 'manual' })}
            />
          )}
        </header>
      </div>
      {(zipEntryType === 'map') && (
        <MapsInterface
          disabled={disabled}
          setReduxProfileKeys={setReduxProfileKeys}
          setReduxAppointments={setReduxAppointments}
          reduxProfile={reduxProfile}
          canEditLocation={canEditLocation}
          awsConfig={awsConfig}
          awsConfigUseDataSite={awsConfigUseDataSite}
          radiusOptions={radiusOptions}
        />
      )}
      {(zipEntryType === 'manual') && (
        <ManualZipEntry
          disabled={disabled}
          setReduxProfileKeys={setReduxProfileKeys}
          reduxProfile={reduxProfile}
          canEditLocation={canEditLocation}
          setManualZipInputValid={setManualZipInputValid}
          manualZipInputValid={manualZipInputValid}
        />
      )}
      {(zipEntryType === 'state') && (
        <StateZipEntry
          disabled={disabled}
          setReduxProfileKeys={setReduxProfileKeys}
          reduxProfile={reduxProfile}
          canEditLocation={canEditLocation}
        />
      )}
    </>
  );
}

export default ZipInterface;
